<template>
    <button
        v-tippy="t('editorToggleClearFormatting')"
        class="flex-none rounded p-1 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-700"
        @click="
            editor.chain().focus().unsetAllMarks().run();
            editor.chain().focus().clearNodes().run();
        "
    >
        <MdiFormatClear class="h-6 w-6" />
    </button>
</template>
<script setup>
    import MdiFormatClear from 'materialdesignicons-vue3/icons/MdiFormatClear.js';

    defineExpose({
        name: 'ClearFormattingButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
